<template>
  <!-- 新日账单明细 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="serchList"
        @reset="reset(initQuery)"
        @changeTime="(value,model)=>changeTime(
          value,
          'searchBar',
          'payTimeStart',
          'payTimeEnd')"
        :loading="tableLoading">
        <template slot="handler">
          <download-button :downloadApi="downloadVipApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;"></download-button>
        </template>
      </mer-search>
    </el-card>
    <!-- summary 汇总信息 -->
    <sum-panel :labelMap="sumDetailLabel" :sumInfo="sumDetailInfo"></sum-panel>
    <!-- table 表格 -->
    <el-card shadow="never">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="false">
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import dailyBillMix from '@/views/finance/mixins/vipDailyBill';
import { getVipSummaryApi, getVipTableListApi, downloadVipApi } from '@/api/finance'
import { mapState } from 'vuex'
  // 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '订单号', type: 'input', modelName: 'orderNo', placeholder: '', maxlength: 100 },
  { label: '支付时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false },
  // { label: '状态', type: 'select', modelName: 'orderType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'oilNum', selectValue: 'id' }
]
// 表格参数配置
let tableConfig = [
  { label: '订单号', prop: 'orderNo', width:'160' },
  { label: '油站名称', prop: 'gasName' },
  { label: '订单金额(元)', prop: 'tradeAmount' },
  { label: '应结算金额(元)', prop: 'settlementAmount' },
  { label: '手续费(元)', prop: 'serviceFee' },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount' },
  { label: '状态', prop: 'payState' }
]

export default {
  name: 'vip_dailyBillDetail',
  mixins:[ listPage, queryMix, dailyBillMix ],
  data(){
    return{
      downloadVipApi,
      isGas: 1,
      tableData: {},
      sumDetailInfo: {},
      tradeTime:'',
      formConfig,
      tableConfig,
      gasInfo: [],
      downloadParams: {}
    }
  },
  created(){
    // 获取商户ID（vuex或者sessionStorage）
    this.initPage()
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  methods:{
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    initPage () {
      this.initQuery()
      this.getAllQueryProps()
      this.refresh()
    },  
    // 设置默认查询条件
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 1, 'searchBar', false, 'payTimeStart', 'payTimeEnd')
      const { tradeTime, pickerOptions } = this
      const initObj = { tradeTime: [tradeTime, pickerOptions] }
      this.setSearchConfig(initObj)
    },
    getAllQueryProps(){
      //获取油站
      this.getAllGasStations()
    },
    // 查询表格数据
    serchList () {
      this.search()
    },
    // 查找目标表格索引
    findColumnIndex (key) {
      return this.tableConfig.findIndex(item => item.prop === key)
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      let gasName = this.gasInfo.length && this.searchBar.gasId ? this.gasInfo.filter(item => item.gasId === this.searchBar.gasId)[0].gasName : ''
      this.tableLoading = true
      const data = { ...this.searchBar, gasName , ...this.pagination }
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar, gasName }
      this.getSumInfo(data)
      try{
        const { code, result = [], totalRow = 0 } = await getVipTableListApi(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 列表汇总（统计）信息
    async getSumInfo (data) {
      try{
        const { code, result } = await getVipSummaryApi(data)
        if(code !== 200) return
        this.sumDetailInfo = result
      }catch(err){
        console.log(err)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
</style>
